import React from 'react';
import classNames from 'classnames';
import ElevenLogomark from '@/assets/elevenLogomark.svg';

const ViewerLoader = ({ className, label = 'Loading document' }) => (
  <div role="status" aria-live="polite" className={classNames('flex w-full items-center justify-center', className)}>
    <ElevenLogomark
      role="presentation"
      className={classNames(
        'color-from-bg h-24 w-24 fill-current',
        'animate-logo-breathe motion-reduce:animate-none motion-reduce:opacity-20',
      )}
    />
    <span className="sr-only">{label}</span>
  </div>
);

export default ViewerLoader;
